import { FullContainer } from '@gorila-shared-ui/components';
import { useStyles } from '../../../hooks/useStyles';
import FleetMaintenanceTypeList from '../../fleet/maintenances/FleetMaintenanceTypeList';
import FleetMaintenanceTypesFiltersBar from '../../fleet/maintenances/FleetMaintenanceTypesFiltersBar';

function FleetMaintenanceTypesPage() {
  const { classes } = useStyles();

  return (
    <FullContainer
      verticalFlex
      classNames={classes.basicPageContainer}
    >
      <FleetMaintenanceTypesFiltersBar />
      <FleetMaintenanceTypeList />
    </FullContainer>
  );
}

export default FleetMaintenanceTypesPage;
